'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_TYPES = undefined;

var _immutable = require('immutable');

var _paths = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _getFeisAge = require('ifeis-isomorphic/lib/utilities/getFeisAge');

var _getFeisAge2 = _interopRequireDefault(_getFeisAge);

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/feiseanna/paths');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_TYPES = exports.EVENT_TYPES = (0, _immutable.List)([{
  value: 'G',
  label: 'Grades',
  hasLevels: true,
  levelsLabel: 'Level'
}, {
  value: 'C',
  label: 'Championships',
  hasLevels: false
}, {
  value: 'F',
  label: 'Figures',
  hasLevels: false
}, {
  value: 'S',
  label: 'Specials',
  hasLevels: true,
  levelsLabel: 'Category'
}]);

exports.default = function (feis_id, event_id) {
  var template = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _immutable.Map)();
  var merge = arguments[3];
  return function (state) {
    var feis = state.getIn(['feiseanna', 'one', feis_id]) || (0, _immutable.Map)();
    var participants = state.getIn((0, _paths.participantsPath)(event_id)) || (0, _immutable.List)();
    var event = template;

    var groupFees = (0, _paths2.getGroupFeesForFeis)(state, feis_id);
    var eventGroupFee = template && template.get('groupFeeId') && merge ? groupFees.find(function (fee) {
      return fee.get('id') === template.get('groupFeeId');
    }) : (0, _paths.getGroupFeeAssignedToEvent)(state, event_id);
    if (groupFees.get('loading') || eventGroupFee && eventGroupFee.get('loading')) {
      return {
        loading: true,
        feis: feis,
        event: event,
        selectedParticipants: (0, _immutable.List)(),
        participants: participants,
        types: EVENT_TYPES.toJS()
      };
    }

    if (event_id) {
      event = state.getIn((0, _paths.eventsPath)(feis_id)).find(function (e) {
        return e.get('id') === event_id;
      }) || event;
    }

    // FIXME(joshdmiller): update template and controller so this isn't necessary
    event = event.toJS();

    if (feis.get('loading') || event.loading) {
      return {
        types: EVENT_TYPES.toJS(),
        feis: feis,
        participants: participants,
        selectedParticipants: (0, _immutable.List)(),
        event: event,
        groupFees: groupFees,
        eventGroupFee: eventGroupFee,
        groupFeeObj: JSON.stringify((groupFees.find(function (g) {
          return g.get('id') === eventGroupFee.get('id');
        }) || (0, _immutable.Map)()).toJS())
      };
    }

    if (!participants.get('loading')) {
      participants = participants.map(function (p) {
        return p.set('$$feisAge', (0, _getFeisAge2.default)(feis, p));
      }).map(function (p) {
        return p.set('$$orderByDOB', (0, _moment2.default)(p.get("dob")).format('YYYY/MM/DD'));
      });
    }

    var placementsCalculation = void 0;
    var customFee = void 0;
    var restrictGender = void 0;
    var medalRounds = void 0;

    if (event.place_cnt) {
      placementsCalculation = 'CNT';
    } else if (event.place_pct) {
      placementsCalculation = 'PCT';
    } else if (event.nafc_or_place_pct) {
      placementsCalculation = 'NAFCorPercent';
    } else if (event.nafc_or_place_cnt) {
      placementsCalculation = 'NAFCorNumber';
    } else {
      placementsCalculation = 'NAFC';
    }

    if (typeof event.fee === 'number' || eventGroupFee.size > 0) {
      customFee = true;
    }

    if (event.gender) {
      restrictGender = true;
    }

    if (!event.rounds) {
      event.rounds = 1;
    }

    if (typeof event.medalRounds === 'number') {
      event.medalRounds = parseFloat(event.medalRounds, 10);
      medalRounds = 1;
    }

    var eventLevels = (state.getIn(['feiseanna', 'one', 'eventLevels', feis_id]) || (0, _immutable.Map)()).toJS();
    var eventTypes = (state.getIn(['feiseanna', 'one', 'eventTypes', feis_id]) || (0, _immutable.Map)()).toJS();

    return {
      loading: false,
      types: EVENT_TYPES.toJS(),
      feis: feis,
      participants: participants,
      event: event,

      selectedParticipants: (0, _immutable.List)(),
      placementsCalculation: placementsCalculation,
      customFee: customFee,
      restrictGender: restrictGender,
      originalEventName: event.name,
      medalRounds: medalRounds,

      editing: event.id ? true : false,
      type: EVENT_TYPES.find(function (t) {
        return t.value === event.type;
      }),

      eventLevels: eventLevels,
      eventTypes: eventTypes,
      groupFees: groupFees,
      eventGroupFee: eventGroupFee,
      groupFeeObj: JSON.stringify((groupFees.find(function (g) {
        return g.get('id') === eventGroupFee.get('id');
      }) || (0, _immutable.Map)()).toJS())
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./syllabus/editor/mapStateToController.js
// module id = 608
// module chunks = 0